import { createAction } from '@reduxjs/toolkit';

import { CHECK_EXTRA_ROOM_REQUEST } from '../constants/extra-rooms';

export {
  getPackagesForRoomUpgrade as getPackagesForRoomUpgradedAction,
  getPackagesForRoomUpgradeSuccess as getPackagesForRoomUpgradedSuccessAction,
  getPackagesForRoomUpgradeFail as getPackagesForRoomUpgradedFailAction,
} from '../reducers/extra-rooms';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const checkExtraRoomRequestAction = createAction<any>(
  CHECK_EXTRA_ROOM_REQUEST,
);
